import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from 'components/ds';

interface MeetingTypeTagProps {
    isRegular?: boolean;
    className?: string;
}

/**
 * 모임 유형 태그 — 모임명 옆에 작은 칩으로 노출.
 * 정기모임 / 일반모임 구분 (isRegularMeeting 기반).
 *
 * 그라데이션 칩을 쓰던 것을 ds Badge 로 바꿨습니다. 정기는 계속 도는 모임이라
 * 테두리 대신 채운 면(weak)으로, 일반은 테두리만으로 둡니다.
 */
export const MeetingTypeTag: React.FC<MeetingTypeTagProps> = ({ isRegular, className }) => {
    const { t } = useTranslation();
    return (
        <Badge tone={isRegular ? 'weak' : 'outline'} className={className}>
            {isRegular ? t('meetingType.regular') : t('meetingType.normal')}
        </Badge>
    );
};
